import React from 'react';

import {
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip as TooltipRC,
  Legend
} from 'recharts';
import type { TickItem } from 'recharts/types/util/types';
import type { ILineChartData } from 'v2/interfaces/dashboard';

import CustomTooltip from './CustomTooltip';

interface IProps {
  data: ILineChartData[];
  totalGains: number;
}

interface ILabelProps {
  payload?: TickItem;
  y?: number;
  x?: number;
}

interface ILegendProps {
  payload?: any[];
}

const LegendContent = ({ payload }: ILegendProps) => {
  return (
    <ul className='my-4 -mr-4 ml-0 flex list-none items-center justify-center'>
      {payload?.map(entry => (
        <li className='mr-[15px] flex text-[13px] font-semibold' key={entry.value}>
          <span className='mr-3 block h-[18px] w-[3px] rotate-45 rounded-xs' style={{ backgroundColor: entry.color }} />
          {entry.value}
        </li>
      ))}
    </ul>
  );
};

const DatePick = ({ payload, y, x, ...rest }: ILabelProps) => {
  return (
    <>
      <text y={y + 15} x={x - 15} {...rest} color='#B0BEC5'>
        {payload.value}
      </text>
    </>
  );
};

const Chart = ({ data, totalGains }: IProps) => {
  const isNegativeGains = totalGains < 0;

  return (
    <ResponsiveContainer width='100%' height={280}>
      <LineChart
        data={data}
        margin={{
          left: -7,
          right: 16,
          bottom: 11
        }}
      >
        <Legend offset={50} verticalAlign='top' content={<LegendContent />} />
        <Line dataKey='producer' name='Produtor' stroke='#FF5C00' fill='#FF5C00' strokeWidth={2} dot />
        <Line dataKey='coproducer' name='Coprodutor' stroke='#FFBE00' fill='#FFBE00' strokeWidth={2} dot />
        <Line dataKey='affiliate' name='Afiliado' stroke='#14286E' fill='#14286E' strokeWidth={2} dot />
        <CartesianGrid strokeDasharray='0' />
        <XAxis dataKey='date' fontSize={12} interval={data.length < 10 && 0} tick={<DatePick />} />
        <YAxis
          type='number'
          allowDecimals={false}
          interval='preserveStartEnd'
          fontSize={13}
          domain={[0, isNegativeGains ? Math.abs(totalGains) : 'auto']}
        />
        <TooltipRC content={<CustomTooltip />} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default Chart;
